export enum TASK_RELEVANCE_VALUES {
  RELEVANT = 'Relevant',
  NON_RELEVANT = 'Not Relevant'
}
